import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const TypingText2 = ({ 
  texts = [], // Array of strings to display
  speed = 80, 
  delay = 0, 
  pauseBetweenTexts = 2000, // Pause before switching to the next string
  classText = "intro" 
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentStringIndex, setCurrentStringIndex] = useState(0);
  const [typingForward, setTypingForward] = useState(true); // Typing forward or deleting
  const [opacity, setOpacity] = useState(true); // For toggling opacity

  useEffect(() => {
    if (!texts || texts.length === 0) return;

    const currentText = texts[currentStringIndex];

    const handleTyping = () => {
      const interval = setInterval(() => {
        setDisplayedText((prevText) => {
          if (typingForward) {
            // Typing forward
            if (prevText.length < currentText.length) {
              return currentText.slice(0, prevText.length + 1);
            } else {
              clearInterval(interval);
              setTimeout(() => {
                // Trigger opacity toggling
                const opacityInterval = setInterval(() => {
                  setOpacity((prev) => !prev);
                }, 500); // Toggle every 500ms

                // Stop opacity toggling after 2 toggles
                setTimeout(() => {
                  clearInterval(opacityInterval);
                  setOpacity(true); // Ensure opacity is on
                  setTimeout(() => setTypingForward(false), 1000); // Start deleting after 1s
                }, 2000);
              }, pauseBetweenTexts);
              return prevText;
            }
          } else {
            // Deleting backward
            if (prevText.length > 0) {
              return prevText.slice(0, -1);
            } else {
              clearInterval(interval);
              setTypingForward(true);
              setCurrentStringIndex((prevIndex) => (prevIndex + 1) % texts.length); // Move to the next string
              return '';
            }
          }
        });
      }, speed);
    };

    const timer = setTimeout(handleTyping, delay);
    return () => clearTimeout(timer);
  }, [texts, speed, delay, currentStringIndex, typingForward, pauseBetweenTexts]);

  return (
    <span 
      className={classText} 
      // style={{ opacity: opacity ? 1 : 0.2, transition: 'opacity 0.5s' }}
    >
      {displayedText}
    </span>
  );
};

TypingText2.propTypes = {
  texts: PropTypes.arrayOf(PropTypes.string).isRequired, // Array of strings
  speed: PropTypes.number,
  delay: PropTypes.number,
  pauseBetweenTexts: PropTypes.number,
  classText: PropTypes.string,
};

export default TypingText2;
